import { hasConsent } from '@utils/cookieConsent'
import { getAnalyticsContext } from './context'

const ECOMMERCE_EVENT_NAMES = process.env.GATSBY_STORE !== "PH"
	? { view_item: "dl_view_item", add_to_cart: "dl_add_to_cart", remove_from_cart: "dl_remove_from_cart" }
	: { view_item: "view_item", add_to_cart: "dl_add_to_cart", remove_from_cart: "dl_remove_from_cart" }

export const sendGAEvent = (eventName, eventParams = {}) => {
	if (typeof window === "undefined") return

	// Only send analytics events if user has consented to analytics
	if (!hasConsent('analytics')) {
		return
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ event: eventName, ...getAnalyticsContext(), ...eventParams })
	// console.table("dataLayer:", window.dataLayer)
}

export const sendEcommerceEvent = (eventName, eventParams = {}) => {
	if (typeof window === "undefined") return
	if (!hasConsent('analytics')) return

	window.dataLayer = window.dataLayer || []
	window.dataLayer.push({ ecommerce: null })
	window.dataLayer.push({
		event: ECOMMERCE_EVENT_NAMES[eventName] || eventName,
		...getAnalyticsContext(),
		...eventParams,
	})
}
